<div [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <mat-dialog-content>
    <div fxFill style='background-color: #e4e4e4'>
      <vrm-dialog-header
        [dialogTitle]="'GENERIC.editFilters' | translate | uppercase"
        [headerBgColour]="'#C9C9C9'"
        headerTextColour='black'
        [hideDivider]='true'
      >
      </vrm-dialog-header>

      <div fxLayout='row wrap' class='filter-body' *ngIf='filterGroups.length > 0'>
        <div class='padding-25' *ngFor='let filterGroup of filterGroups'>
          <div *ngIf='filterGroup.canSelectMultipleValues; else singleSelect'>
            <div class='bold padding-b-15'>
              <mat-checkbox
                color='primary'
                [checked]='filterGroup.allSelected'
                [indeterminate]='filterGroup.someSelected'
                (change)='selectAllFiltersForGroup($event.checked, filterGroup)'
              >
                {{ filterGroup.name | uppercase }}
              </mat-checkbox>
            </div>

            <div [ngStyle]='{ columns: filterGroups.length > 1 ? 1 : 2 }'>
              <div *ngFor='let filter of filterGroup.filters' class='padding-b-15'>
                <mat-checkbox
                  (change)='updateGroupState(filterGroup)'
                  [(ngModel)]='filter.isSelected'
                  color='primary'
                >
                  {{ filter.name }}
                </mat-checkbox>
              </div>
            </div>
          </div>
          <ng-template #singleSelect>
            <div class='bold padding-b-15'>{{ filterGroup.name | uppercase }}</div>
            <div [style.columns]="filterGroups.length === 1 ? 2 : 'auto'">
              <mat-radio-group (change)='selectRadioFilter($event.value, filterGroup)'>
                <div *ngFor='let filter of filterGroup.filters' class='padding-b-15'>
                  <mat-radio-button [value]='filter' [checked]='filter.isSelected' color='primary'>
                    {{ filter.name }}
                  </mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </ng-template>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div fxLayout='row' fxLayoutAlign='center' class='padding-25'>
        <button
          type='button'
          mat-button
          vrm-bg-color
          class='bold'
          (click)='applySelectedFilters()'
          mat-dialog-close
        >
          {{ 'GENERIC.applyFilters' | translate | uppercase }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>
